import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu, Icon } from 'antd';
import styles from './index.less';

const { Sider } = Layout;

class SideMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.menus = props.menuData;
  }

  /**
   * Return the redirect Link dom of the menu item
   */
  getMenuItemPath = (item) => {
    const itemPath = item.path || '';
    const name = item.name || '';
    const icon = item.icon ? <Icon type={item.icon} /> : null;
    
    return <Link to={`/${itemPath}`}>{icon}<span>{name}</span></Link>;
  };

  /**
   * Return an array of the side menu item DOMs
   */
  getMenuItemDoms = (menuData) => {
    if (!menuData) {
      return [];
    }
    return menuData.map(item => <Menu.Item key={item.path}>{this.getMenuItemPath(item)}</Menu.Item>);
  };

  /**
   * Return an array of key string of the selected keys mapping the pathname.
   * '/admin/22' --> ['admin','22'];
   */
  getSelectedMenuKeys = () => {
    const { location: { pathname } } = this.props;
    return pathname.split('/');
  };

  render() {
    return (
      <Sider
        width={256}
        className={styles.sider}
      >
        <div className="logo">
          <Link to="/">
            <h1>OVP3 Support App</h1>
          </Link>
        </div>
        <Menu
          key="Menu"
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['tenant']}
          selectedKeys={this.getSelectedMenuKeys()}
        >
          {this.getMenuItemDoms(this.menus)}
        </Menu>
      </Sider>
    );
  }
}

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/SideMenu/index.js